module.exports = __webpack_public_path__ + "img/scan.34c320c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/scan.jpg
// module id = hNuR
// module chunks = 1